import React, { useState } from 'react';
import { useStepContext } from '../utils/StepContext.jsx';
import { useFormContext } from "../utils/FormContext.jsx"
import { motion, AnimatePresence } from 'framer-motion';
import ProgressBar from './ProgressBar/ProgressBar.jsx';
// import SearchCard from './SearchCard.jsx';
// import ResultsCard from './ResultsCard.jsx';

import NewSearchCard from './SearchandResult/NewSearchCard.jsx';
import NewResultCard from './SearchandResult/NewResultCard.jsx';

import NameCard from './NameCard.jsx'
import TenantsCard from './TenantsCard.jsx';
import DatesDeadlines from './Dates&Deadlines/DatesDeadlines.jsx';
import PriceTerms from './PurchasingPrice&Terms/PriceTerms.jsx';
import Title from './Title/Title.jsx';
import IlcSurvey from './ILC&Survey/IlcSurvey.jsx';
import DisclosureInspection from './Disclosure&Inspection/DisclosureInspection.jsx';
import ClosingCosts from './ClosingCosts/ClosingCosts.jsx';
import Prorations from './Prorations/Prorations.jsx';
import Possession from './Possessions/Possession.jsx';
import AdditionalProvisions from './AdditionalProvisions/AdditionalProvisions.jsx';
import FinalReview from './FinalReview/FinalReview.jsx';
import ContractPDF from '../utils/PDFGen/ContractPDF.jsx';
import PriceTerms2 from './PurchasingPrice&Terms/PriceTerms2.jsx';
import WaterRights from './WaterRights/WaterRights.jsx';
import PacketSign from './PacketSigning/PacketSign.jsx';
import PacketComplete from './PacketSigning/PacketComplete.jsx';
import SellersCard from './SellersCard.jsx';
import Miscellaneous from './Miscellaneous/Miscellaneous.jsx';
import ConfirmationModal from './ConfirmationModal.jsx';
import PreStepMiscellaneous from './Miscellaneous/PreStepMiscellaneous.jsx';
import ShishitoAnimation from './Animation/ShishitoAppear';

const StepRenderer = ({ height }) => {
  const { currentStep, direction, currentPageValue, currentSubStepProgress, handleNextStep, showAnimation, handleAnimationComplete } = useStepContext();
  const { showConfirmationModal, setShowConfirmationModal, handleSignIn, handleCreateAccount } = useFormContext();

  const slideVariants = {
    enter: (direction) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0,
      position: 'absolute',
      width: '100%'
    }),
    center: {
      x: 0,
      opacity: 1,
      position: 'relative',
      width: '100%'
    },
    exit: (direction) => ({
      x: direction < 0 ? 1000 : -1000,
      opacity: 0,
      position: 'absolute',
      width: '100%'
    })
  };

  const renderStep = () => {
    if (showAnimation) {
      return <ShishitoAnimation onComplete={handleAnimationComplete} />;
    }

    switch (currentStep) {
      case 0:
        //   return <SearchCard />;
        return <NewSearchCard />;
      case 1:
        //   return <ResultsCard />;
        return <NewResultCard />;
      case 2: 
        return <NameCard />; 
      case 3: 
        return <SellersCard />;
      case 4:
        return <TenantsCard />; 
      case 5: 
        return <PreStepMiscellaneous />; 
      // case 5: 
      //     return <WaterRights />;
      case 6: 
        return <Miscellaneous />;
      case 7: 
        return <DatesDeadlines />; 
      case 8: 
        return <PriceTerms />;
      case 9: 
        return <PriceTerms2 />; 
      case 10: 
        return <Title />; 
      case 11: 
        return <IlcSurvey />;  
      case 12: 
        return <DisclosureInspection />;
      case 13: 
        return <ClosingCosts />; 
      case 14: 
        return <Prorations />; 
      case 15: 
        return <Possession />; 
      case 16: 
        return <AdditionalProvisions />; 
      case 17: 
        return <FinalReview />; 
      case 18: 
        return <PacketSign />;  
      case 19:
        return <PacketComplete />;
      // Add cases for other steps here
      default:
        return <NewSearchCard />;
    }
  }; 

  return (
    <div className="flex flex-col w-full h-full">
      {currentStep >= 2 && currentStep < 18 && (
        <div className="sticky top-0 z-10 flex w-full justify-center">
          <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress} />
        </div>
      )}
      <div className="flex-1 relative overflow-hidden w-full">
        <AnimatePresence initial={false} custom={direction}>
          <motion.div
            key={currentStep}
            custom={direction}
            variants={slideVariants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{
              x: { type: "spring", stiffness: 200, damping: 30, duration: 0.2 },
              opacity: { duration: 0.2 }
            }}
            style={{ height }}
            className="w-full"
          >
            {renderStep()}
          </motion.div>
        </AnimatePresence>
      </div>
      {showConfirmationModal && (
        <ConfirmationModal
          isOpen={showConfirmationModal}
          onClose={() => setShowConfirmationModal(false)}
          onCreateAccount={handleCreateAccount}
          onSignIn={handleSignIn}
        />
      )}
    </div>
  );
};

export default StepRenderer;